import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import { createPinia } from 'pinia'
import GlobalComponents from './components/index'

import ElementPlus from 'element-plus'
//配置Element图标
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
//自定义主题
import './styles/element/index.scss'

/* 引入公共样式 */
import './styles/index.css'

import 'virtual:svg-icons-register'

//引入iconfont图标
import './assets/iconfont/iconfont.js'

const pinia = createPinia()

const app = createApp(App)

for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}

app.use(router).use(pinia).use(GlobalComponents).use(ElementPlus)

app.mount('#app')
